import { Box, Button, List, PopoverMenu, Text } from '@factorialco/deprecated-design-system'
import { ComplianceExtraFieldDefaultSettingFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  defaultComplianceExtraFieldSetting: ComplianceExtraFieldDefaultSettingFragment
  onEdit: () => void
  onDelete: () => void
}

export const ListItemDefaultComplianceExtraFieldSetting = ({
  defaultComplianceExtraFieldSetting,
  onEdit,
  onDelete,
}: Props) => {
  return (
    <List.Item>
      <Box flexDirection="column" gap="s4">
        <Text.Normal weight="semibold">
          {defaultComplianceExtraFieldSetting.organization.toUpperCase()}
        </Text.Normal>
        <Text.Normal size="100">
          {defaultComplianceExtraFieldSetting.legalEntity.legalName}
        </Text.Normal>
      </Box>
      <Box flexDirection="column" justifyContent="spaceBetween" height="full">
        <Box flexDirection="column" justifyContent="center" height="full" alignItems="flexEnd">
          <PopoverMenu type="list">
            <PopoverMenu.Trigger asChild>
              <Button iconName="ellipsis" type="secondary" />
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="end">
              <PopoverMenu.TouchableOption
                title={i18n.t('common.edit')}
                icon="pencil"
                onClick={onEdit}
              />
              <PopoverMenu.TouchableOption
                title={i18n.t('common.delete')}
                icon="delete"
                danger
                onClick={onDelete}
              />
            </PopoverMenu.Content>
          </PopoverMenu>
        </Box>
      </Box>
    </List.Item>
  )
}
